module.exports = __webpack_public_path__ + "ab07d892b1d3eec8c56fc5fb53eaf86b.svg";